import TimelineItem from "types/TimelineItem";
import TimelinePositions from "../types/TimelinePositions";

/**
 * This function calculates the positions of videos on the timeline.
 * It takes an array of timeline videos and returns a map of timeline positions.
 * The values are the videos, the keys are the start times of the videos.
 *
 * @param {TimelineItem[]} timelineItems - The videos to position on the timeline.
 * @returns {TimelinePositions} A map of timeline positions.
 */
export default function getTimelinePositions(
  timelineItems: TimelineItem[],
): TimelinePositions {
  const timelinePositions: TimelinePositions = new Map();

  let startTimePosition = 0;
  timelineItems.forEach((timelineItem) => {
    timelinePositions.set(startTimePosition, timelineItem);
    const currentDuration = timelineItem.endTime - timelineItem.startTime;
    startTimePosition = startTimePosition + currentDuration;
  });

  return timelinePositions;
}
